<i18n src="./resources/locales.json" />

<template>
  <section class="interaction-detail-dynamic-field">
    <EcsCustomInput
      v-if="isFlag"
      type="flag"
      dense
      :value="interactionVariable.value === 'True'"
      :disabled="!isEditable"
      :label="displayName"
      @change="updateField"
    />
    <EcsCustomInput
      v-else-if="isValueSet"
      type="select"
      dense
      :value="interactionVariable.value"
      :items="valueSetItems"
      :disabled="!isEditable"
      :label="displayName"
      @change="updateField"
    />
    <v-text-field
      v-else
      v-model="valueToStore"
      :value="interactionVariable.value"
      :label="displayName"
      :readonly="!isEditable"
      :disabled="!isEditable"
      @focus="() => (tmpValue = valueToStore)"
      @change="updateField"
    >
      <template slot="append">
        <v-tooltip top z-index="9999">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" class="action-btn" v-on="on" @click="copyToClipboard">
              mdi-content-copy
            </v-icon>
          </template>
          <span>{{ $t('copy', { fieldName: displayName }) }}</span>
        </v-tooltip>
      </template>
    </v-text-field>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import InteractionService from '@/services/interactionService';
import { INTERACTION_VARIABLES } from '@/constants/interaction/constants';

export default {
  name: 'InteractionDetailDynamicField',

  props: {
    interactionId: {
      type: String,
      required: true
    },
    fieldFromTemplate: {
      type: Object,
      required: true
    },
    interactionVariable: {
      type: Object,
      required: true,
      default: () => ({ name: '', value: '' })
    }
  },

  data() {
    return {
      tmpValue: this.interactionVariable.value,
      valueToStore: this.interactionVariable.value
    };
  },

  computed: {
    ...mapGetters('ORGANIZATION', ['interactionVariables']),

    ...mapGetters('REFERENCES', ['valueSets']),

    // fieldFromTemplate = { displayName, editable, format, interactionVariableName, order }
    // fieldFromConfiguration = { name, propertyType, type }
    // interactionVariable = { name, value }

    displayName() {
      return this.fieldFromTemplate.displayName;
    },

    isEditable() {
      return this.fieldFromTemplate.editable;
    },

    isValueSet() {
      return this.fieldFromConfiguration.propertyType === INTERACTION_VARIABLES.TYPES.valueSet;
    },

    valueSetItems() {
      return (this.valueSets.find(valueSet => valueSet.name === this.fieldFromConfiguration.type) || {}).values || [];
    },

    isFlag() {
      return this.fieldFromConfiguration.type === INTERACTION_VARIABLES.SIMPLE_SUB_TYPES.flag;
    },

    fieldFromConfiguration() {
      return this.interactionVariables.find(
        variable => variable.name === this.fieldFromTemplate.interactionVariableName
      );
    }
  },

  methods: {
    updateField(newValue) {
      InteractionService.updateInteractionVariable({
        interactionId: this.interactionId,
        variableName: this.fieldFromConfiguration.name,
        value: newValue
      })
        .then(() => {
          this.$root.$emit('snackbar-message', {
            message: this.$t('updateSuccess', { label: this.displayName }),
            type: 'success'
          });
        })
        .catch(() => {
          this.valueToStore = this.tmpValue;
          this.$root.$emit('snackbar-message', {
            message: this.$t('updateError', { label: this.displayName }),
            type: 'error'
          });
        });
    },

    copyToClipboard() {
      navigator.clipboard
        .writeText(this.valueToStore || '')
        .then(() => {
          this.$root.$emit('snackbar-message', {
            message: this.$t('copySuccess', { label: this.displayName }),
            type: 'success'
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.interaction-detail-dynamic-field {
  display: block;
}
</style>
